import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function cancelSubscriptionReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.POST_CANCEL_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.POST_CANCEL_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.POST_CANCEL_SUBSCRIPTION_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
